import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import AnonymousUserIcon from '../Icons/AnonymousUserIcon';

import classNames from 'classnames';
import s from './Avatar.css';

const defaultSize = 70;

/**
 * Avatar
 */
export default class Avatar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      actualSrc: props.src
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      actualSrc: newProps.src
    });
  }

  handleError = () => {
    this.setState({
      actualSrc: null
    });
  };

  render() {
    let icon = this.props.icon;
    const {
      letter,
      string,
      size,
      inactive,
      className,
      style,
      innerClassName,
      innerStyle,
      letterClassName,
      letterStyle,
      outerClassName
    } = this.props;
    let actualSize = size;
    const src = this.state.actualSrc;
    let actualLetter;
    if (letter) {
      actualLetter = letter
        .toString()
        .trim()
        .toUpperCase();
      actualLetter = actualLetter.length > 0 ? actualLetter[0] : null;
    }
    if (string) {
      actualLetter = string;
    }

    if (!icon && !actualLetter) {
      let delta = 15;
      if (size > 30) {
        delta = Math.round(size / 2);
      }
      let height = size - delta;
      if (size <= 30) {
        height = 16;
        actualSize = 30;
      }
      // See AnonymousUserIcon proportion
      const anonStyle = Object.assign(
        {
          width: Math.round((height * 37) / 48) + 'px',
          height
        },
        innerStyle
      );
      icon = <AnonymousUserIcon className={innerClassName} style={anonStyle} />;
    } else if (!icon && actualLetter) {
      let fontSize = Math.round(size / 3);
      if (size <= 20) {
        fontSize = 12;
        actualSize = 20;
      }
      icon = (
        <span
          className={classNames(s.Letter, letterClassName)}
          style={{...letterStyle, fontSize}}
        >
          {actualLetter}
        </span>
      );
    }

    let defaultStyle = {
      width: actualSize,
      height: actualSize
    };
    const computedStyle = Object.assign({}, defaultStyle, style);

    return (
      <div
        aria-hidden="true"
        className={classNames(
          s.Avatar,
          s.Inner,
          inactive && s.Inactive,
          className,
          outerClassName
        )}
        style={computedStyle}
      >
        {src ? (
          <img
            src={src}
            alt=""
            className={classNames(s.Image, innerClassName)}
            style={innerStyle}
            onError={this.handleError}
          />
        ) : (
          icon
        )}
      </div>
    );
  }
}
Avatar.propTypes = {
  /**
   * The icon element to use
   */
  icon: PropTypes.element,
  /**
   * The src of the image to use
   */
  src: PropTypes.string,
  /**
   * Display a letter instead of the default icon
   */
  letter: PropTypes.string,
  /**
   * Display a string instead of the default icon
   */
  string: PropTypes.string,
  /**
   * The size of the avatar
   */
  size: PropTypes.number,
  /**
   * The size of the avatar
   */
  inactive: PropTypes.bool,
  /**
   * Container class name
   */
  className: PropTypes.string,
  /**
   * Container styles
   */
  style: PropTypes.object,
  /**
   * Inner element class name; when using an icon, put the class name directly on the element
   */
  innerClassName: PropTypes.string,
  /**
   * Inner element styles; when using an icon, put the style directly on the element
   */
  innerStyle: PropTypes.object,
  /**
   * Letter class name
   */
  letterClassName: PropTypes.string
};
Avatar.defaultProps = {
  size: defaultSize,
  inactive: false
};
